"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash256 = void 0;
exports.createPublicKey = createPublicKey;
exports.randomBytes = randomBytes;
exports.sha256 = sha256;
exports.hashConcat = hashConcat;
exports.checkSignature = checkSignature;
exports.checkDigestSignature = checkDigestSignature;
exports.sign = sign;
exports.signDigest = signDigest;
exports.makeKeyPair = makeKeyPair;
exports.makeTuid = makeTuid;
exports.verifyKeyPair = verifyKeyPair;
const buffer_1 = require("buffer");
const crypto = __importStar(require("crypto"));
const secp256k1 = __importStar(require("secp256k1"));
const formatter_1 = require("../formatter");
const errors_1 = require("./errors");
function createPublicKey(privKey) {
    validatePrivKeyFormat(privKey);
    return buffer_1.Buffer.from(secp256k1.publicKeyCreate(privKey, true).buffer);
}
function randomBytes(size) {
    return crypto.randomBytes(size);
}
function sha256(buffer) {
    return crypto.createHash("sha256").update(buffer).digest();
}
exports.hash256 = sha256;
function hashConcat(items) {
    return (0, exports.hash256)(buffer_1.Buffer.concat(items));
}
/**
 * @param content the content that the signature signs. It will be digested before validating.
 * @param pubKey The pubKey to validate the signature with
 * @param signature the signature to validate
 *
 * @return true if signature ok, false otherwise
 */
function checkSignature(content, pubKey, signature) {
    const digest = (0, exports.hash256)(content);
    return checkDigestSignature(digest, pubKey, signature);
}
/**
 * @param digest the signed digest. It will not be digested before validating.
 * @param pubKey The pubKey to validate the signature with
 * @param signature the signature to validate
 *
 * @return true if signature ok, false otherwise
 */
function checkDigestSignature(digest, pubKey, signature) {
    return secp256k1.ecdsaVerify(signature, digest, pubKey);
}
/**
 * @param content to sign. It will be digested before signing.
 * @param privKey The private key to sign the content with
 *
 * @return the signature
 */
function sign(content, privKey) {
    validatePrivKeyFormat(privKey);
    const digestBuffer = sha256(content);
    return signDigest(digestBuffer, privKey);
}
/**
 * @param digestBuffer to sign. It will not be digested before signing.
 * @param privKey The private key to sign the digest with
 *
 * @return the signature
 */
function signDigest(digestBuffer, privKey) {
    return buffer_1.Buffer.from(secp256k1.ecdsaSign(digestBuffer, privKey).signature);
}
/**
 * Creates a key pair (which usually represents one user)
 * @param privKey to create key pair based on
 * @returns {{pubKey: Buffer, privKey: Buffer}}
 */
function makeKeyPair(privKey) {
    let pubKey;
    if (privKey) {
        privKey = (0, formatter_1.ensureBuffer)(privKey);
        pubKey = createPublicKey(privKey);
    }
    else {
        do {
            privKey = randomBytes(32);
        } while (!secp256k1.privateKeyVerify(privKey));
        pubKey = buffer_1.Buffer.from(secp256k1.publicKeyCreate(privKey).buffer);
    }
    return { pubKey, privKey };
}
/**
 * Generates a 16bytes TUID (Text unique ID) (a 32characters long string)
 * @returns string
 */
function makeTuid() {
    return randomBytes(16).toString("hex");
}
/**
 * Verify that keypair is correct. Providing the private key, this function returns its associated public key
 * @param privKey: Buffer
 * @returns {{pubKey: Buffer, privKey: Buffer}}
 */
function verifyKeyPair(privKey) {
    validatePrivKeyFormat(privKey);
    const pubKey = buffer_1.Buffer.from(secp256k1.publicKeyCreate(privKey).buffer);
    return { pubKey, privKey };
}
function validatePrivKeyFormat(privKey) {
    if (!privKey) {
        throw new errors_1.MissingPrivKeyArgumentException();
    }
    if (!buffer_1.Buffer.isBuffer(privKey) || privKey.length !== 32) {
        throw new errors_1.PrivKeyFormatException(privKey);
    }
}
//# sourceMappingURL=encryption.js.map